import React from "react";
import styles from "../SubjectSinglePage.module.css";
import type { SubjectActionMenuState, SubjectItem } from "../model/types";

type SubjectModalAction = "add" | "update" | "show" | "delete";

type SubjectActionMenuProps = {
  actionMenu: SubjectActionMenuState | null;
  menuRef: React.RefObject<HTMLDivElement>;
  isRegisteredUser: boolean;
  isSubjectModerator: boolean;
  onClose: () => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  onChooseSubject: (subjectId: number) => void;
  onViewSubjectGists: (subjectId: number) => void;
  onOpenSubjectModal: (subject: SubjectItem, action: SubjectModalAction) => void;
};

export const SubjectActionMenu: React.FC<SubjectActionMenuProps> = ({
  actionMenu,
  menuRef,
  isRegisteredUser,
  isSubjectModerator,
  onClose,
  onKeyDown,
  onChooseSubject,
  onViewSubjectGists,
  onOpenSubjectModal,
}) => {
  if (!actionMenu) return null;

  return (
    <>
      <button
        type="button"
        className={styles.actionMenuScrim}
        aria-label="Close subject actions"
        onClick={onClose}
      />
      <div
        ref={menuRef}
        className={styles.actionMenu}
        role="menu"
        aria-label={`Actions for ${actionMenu.subject.title}`}
        style={{ left: actionMenu.x, top: actionMenu.y }}
        onKeyDown={onKeyDown}
      >
        <div className={styles.actionMenuTitle}>{actionMenu.subject.title}</div>
        <button
          type="button"
          role="menuitem"
          onClick={() => onChooseSubject(actionMenu.subject.id)}
        >
          <span>↗</span> Explore
        </button>
        <button
          type="button"
          role="menuitem"
          onClick={() => onViewSubjectGists(actionMenu.subject.id)}
        >
          <span>▤</span> View gists
        </button>
        <button
          type="button"
          role="menuitem"
          disabled={!isRegisteredUser}
          title={isRegisteredUser ? "" : "Login required"}
          onClick={() => onOpenSubjectModal(actionMenu.subject, "add")}
        >
          <span>＋</span> Add subsubject
        </button>
        <button
          type="button"
          role="menuitem"
          disabled={!isSubjectModerator}
          title={isSubjectModerator ? "" : "Moderator only"}
          onClick={() => onOpenSubjectModal(actionMenu.subject, "update")}
        >
          <span>✎</span> Rename
        </button>
        <button
          type="button"
          role="menuitem"
          disabled={!isRegisteredUser}
          title={isRegisteredUser ? "" : "Login required"}
          onClick={() => onOpenSubjectModal(actionMenu.subject, "show")}
        >
          <span>▦</span> Create gist
        </button>
        <button
          type="button"
          role="menuitem"
          className={styles.actionDanger}
          disabled={!isSubjectModerator}
          title={isSubjectModerator ? "" : "Moderator only"}
          onClick={() => onOpenSubjectModal(actionMenu.subject, "delete")}
        >
          <span>⌫</span> Delete subject
        </button>
      </div>
    </>
  );
};
